function initTestimonialsSlider() {
  const sectionWrappers = document.querySelectorAll('.pm-0002-testimonials-section-wrapper');

  sectionWrappers.forEach(sectionWrapper => {
    const sectionId = sectionWrapper.id.replace('pm-0002-testimonials-', '');

    let testimonialsThumbsSwiper;
    let testimonialsMainSwiper;

    function initializeSwipers() {
      testimonialsThumbsSwiper = new Swiper(sectionWrapper.querySelector('.pm-0002-testimonials-mobile-thumbs'), {
        spaceBetween: 15,
        slidesPerView: 4.6,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: false,
            enabled: false
          }
        }
      });

      testimonialsMainSwiper = new Swiper(sectionWrapper.querySelector('.pm-0002-testimonials-main-slider'), {
        loop: false,
        grabCursor: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: `#pm-0002-testimonials-${sectionId} .swiper-pagination`,
          clickable: true,
        },
        navigation: {
          nextEl: `#pm-0002-testimonials-${sectionId} .pm-0002-testimonials-button-next`,
          prevEl: `#pm-0002-testimonials-${sectionId} .pm-0002-testimonials-button-prev`,
        },
        thumbs: {
          swiper: testimonialsThumbsSwiper,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0.77,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 40
          },
        }
      });
    }

    initializeSwipers();
  });
}

document.addEventListener('DOMContentLoaded', initTestimonialsSlider);